
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationCommentSelect = ({ 
    targetField, 
    options = [], 
    placeholder = "Select a comment...",
    className = "",
    disabled = false
}) => {
    const { setValue } = useFormContext();

    const handleChange = (e) => {
        const val = e.target.value;
        if (val) {
            setValue(targetField, val, { shouldDirty: true, shouldValidate: true });
        }
    };

    return (
        <div className={`mb-2 ${className}`}>
            <select
                className={`${FORM_FIELD.control} ${disabled ? FORM_FIELD.disabled : `${FORM_FIELD.enabled} cursor-pointer`}`}
                disabled={disabled}
                onChange={handleChange}
                defaultValue=""
            >
                <option value="" disabled>{placeholder}</option>
                {options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default EvaluationCommentSelect;
